import React, { useRef, useState } from "react";
import { CardMedia, LinearProgress } from "@material-ui/core";
import styled from "styled-components";
import StyledButton from "../../../../../UIcomponent/Button";
import Urls from "../../../../../Utility/Urls";
import ProfileReq from "../../../../../Utility/Requester/ProfileReq";
import { Notify } from "../../../../../UIcomponent/NotificationManager";
import { withStyles } from "@material-ui/styles";

const Container = styled.div`
  .progrress {
    transition: opacity 200ms ease;
    opacity: 0;
    pointer-events: none;
    &.in {
      pointer-events: all;
      opacity: 1;
    }
  }
  .buttons {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    marginTop: 10,
    height: 10,
    borderRadius: 5,
  },
  bar: {
    borderRadius: 5,
  },
}))(LinearProgress);

const Video = (props) => {
  const { video } = props;
  const [showProgress, setShowProgress] = useState(false);
  const [hasVideo, setHasVideo] = useState(false);

  const videoUploadRef = useRef();
  const videoRef = useRef();
  const progressRef = useRef();

  function uploadVideo() {
    videoUploadRef.current.click();
  }

  function updateVideo() {
    let vid = videoRef.current;
    if (videoUploadRef.current.files.length > 0) {
      vid.src = URL.createObjectURL(videoUploadRef.current.files[0]);
      vid.load();
      vid.onended = function () {
        URL.revokeObjectURL(vid.currentSrc);
      };
      setHasVideo(true);
    }
  }

  function onUploadStarted() {
    setShowProgress(true);
  }

  function onUploadFinished() {
    setShowProgress(false);
    videoUploadRef.current.value = "";
    setHasVideo(false);
  }

  function onUploadProgress(progressEvent) {
    var percentCompleted = Math.round(
      (progressEvent.loaded * 100) / progressEvent.total
    );
    progressRef.current.firstChild.style.transform = `translateX(${
      100 - percentCompleted
    }%)`;
  }

  function save() {
    if (videoUploadRef.current.files.length > 0) {
      let formData = new FormData();
      formData.append("intro", videoUploadRef.current.files[0]);
      onUploadStarted();
      ProfileReq.UpdateTeacherVideo({
        data: formData,
        onUploadProgress,
      })
        .then((res) => {
          Notify("success", "ویدئو با موفقیت به روزرسانی شد.", 3000);
          onUploadFinished();
        })
        .catch(() => {
          Notify("error", "خطا در آپلود ویدئو، لطفا دوباره تلاش کنید.", 3000);
          onUploadFinished();
        });
    }
  }

  return (
    <Container>
      <div className="title-bar">
        <h3>ویدئو</h3>
      </div>
      <br />
      <CardMedia
        className={{
          position: "relative",
          minHeight: 400,
        }}
        component="video"
        ref={videoRef}
        src={
          video === ""
            ? "http://localhost:3000/assets/images/female.svg"
            : `${Urls.video()}${video}`
        }
        title=""
        controls
      ></CardMedia>
      <div className={`progrress ${showProgress && "in"}`}>
        <BorderLinearProgress
          variant="determinate"
          value={0}
          ref={progressRef}
          className={{ width: "100%" }}
        />
      </div>
      <br />
      <div className="buttons">
        <StyledButton disabled={showProgress} primary onClick={uploadVideo}>
          بروزرسانی ویديو
        </StyledButton>
        <br />
        {hasVideo ? (
          <StyledButton loading={showProgress} secondary onClick={save}>
            ذخیره سازی
          </StyledButton>
        ) : null}
      </div>
      <input
        onChange={updateVideo}
        accept="video/*"
        type="file"
        style={{ display: "none" }}
        ref={videoUploadRef}
      />
    </Container>
  );
};

export default Video;
